/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Selectlp2Inputs */

const en_coinvestments_selectlp2 = /** @type {(inputs: Coinvestments_Selectlp2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Organisation`)
};

/**
* | output |
* | --- |
* | "Select Organisation" |
*
* @param {Coinvestments_Selectlp2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_selectlp2 = /** @type {((inputs?: Coinvestments_Selectlp2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Selectlp2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_selectlp2(inputs)
});
export { coinvestments_selectlp2 as "coInvestments_selectLp" }